import React, { FC } from 'react';
import { TMember } from './MemberProfile';
import UsersListModalContent from '../UsersListModal/UsersListModalContent';

type TTerritoryMembersModalProps = {
  territoryName: string;
  members: TMember[];
  membersCount: number;
};

const TerritoryMembersModal: FC<TTerritoryMembersModalProps> = ({ members = [], membersCount }) => {
  const sortedUsersList = [...members]?.sort((a, b) => b.cumulativeTimePoints - a.cumulativeTimePoints);
  return <UsersListModalContent totalCount={membersCount} usersList={sortedUsersList} />;
};

export default TerritoryMembersModal;
